import React from 'react';
import { Grid } from '@mui/material';
import { dropBoolean } from 'utils/drops';
import Input from 'components/Input';
import Dropdown from 'components/Dropdown';

const Filter = ({ grid, control, drops }) => {
  const checkDisplay = (name) => {
    const column = grid?.colunas?.find((c) => c?.field === name);
    if (column?.filterable) {
      return true;
    }
    return false;
  };

  return (
    <Grid container spacing={2}>
      {checkDisplay('id') && (
        <Grid item xs={12}>
          <Input name="id" control={control} label="ID" type="number" />
        </Grid>
      )}
      {checkDisplay('etapa') && (
        <Grid item xs={12}>
          <Input name="etapa" control={control} label="Etapa" type="number" />
        </Grid>
      )}
      {checkDisplay('descricao') && (
        <Grid item xs={12}>
          <Input name="descricao" control={control} label="Descrição" />
        </Grid>
      )}
      {checkDisplay('orientacao') && (
        <Grid item xs={12}>
          <Input name="orientacao" control={control} label="Orientação" />
        </Grid>
      )}
      {checkDisplay('responsavel') && (
        <Grid item xs={12}>
          <Dropdown
            name="responsavel"
            control={control}
            label="Responsável"
            options={drops?.Users}
            multiple
          />
        </Grid>
      )}
      {checkDisplay('tempomin') && (
        <Grid item xs={12}>
          <Input
            name="tempomin"
            control={control}
            label="Tempo Mínimo"
            type="number"
          />
        </Grid>
      )}
      {checkDisplay('tempomax') && (
        <Grid item xs={12}>
          <Input
            name="tempomax"
            control={control}
            label="Tempo Máximo"
            type="number"
          />
        </Grid>
      )}
      {checkDisplay('manual') && (
        <Grid item xs={12}>
          <Dropdown
            name="manual"
            control={control}
            label="Manual"
            options={dropBoolean}
          />
        </Grid>
      )}
      {checkDisplay('permite_proposta') && (
        <Grid item xs={12}>
          <Dropdown
            name="permite_proposta"
            control={control}
            label="Permite Proposta"
            options={dropBoolean}
          />
        </Grid>
      )}
      {checkDisplay('proposta') && (
        <Grid item xs={12}>
          <Dropdown
            name="proposta"
            control={control}
            label="Proposta"
            options={dropBoolean}
          />
        </Grid>
      )}
      {checkDisplay('concluir_lead') && (
        <Grid item xs={12}>
          <Dropdown
            name="concluir_lead"
            control={control}
            label="Concluir Lead"
            options={dropBoolean}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default Filter;
